import { defineComponent as _defineComponent } from 'vue'
import { CtDraft } from '@/models/interfaces/content-type'
import { ref } from 'vue'

import DraftProductList from '../../components/DraftProductList.vue'
import AddressEditor from '@/components/AddressEditor.vue'
import ProductSearch from './ProductSearchModal.vue'
import ActionFooter from '@/components/ActionFooter.vue'
import ExternalLinkIcon from '@/components/Icons/ExternalLinkIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DraftEditor',
  props: {
    modelValue: {},
    link: {}
  },
  emits: ['update:model-value', 'close', 'ignore', 'commit', 'address-updated', 'products-updated', 'updated'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit
const showSearch = ref(false)
const target = ref<number>(-1)

function test (e) {
  console.log('test', e)
}

function openMirrorUrl (link) {
  window.open(link, '_blank')?.focus()
}

function searchProducts (index: number) {
  showSearch.value = true
  target.value = index
}

function commitSearch (selection) {
  const updated = props.modelValue

  if (!updated.raw) return console.warn('Tried to update draft products, but the draft had no "raw" field')
  if (target.value === undefined || target.value < 0) return console.warn('Tried to update draft products, but the set target product index was invalid')

  updated.raw.products[target.value] = { ...selection[0], quantity: updated.raw.products[target.value].quantity || 1 }

  target.value = -1
  emit('update:model-value', updated)
}

function ignoreDraft () {
  emit('ignore', props.modelValue.sys.id)
}

function commitDraft () {
  emit('commit', props.modelValue.sys.id, { shipping_address: props.modelValue.raw?.shipping_address, products: props.modelValue.raw?.products })
}

function updateDraftAddress () {
  emit('address-updated', props.modelValue.raw?.shipping_address)
}
function updateDraftProducts () {
  emit('products-updated', props.modelValue.raw?.products)
}


const __returned__ = { props, emit, showSearch, target, test, openMirrorUrl, searchProducts, commitSearch, ignoreDraft, commitDraft, updateDraftAddress, updateDraftProducts, get CtDraft() { return CtDraft }, ref, DraftProductList, AddressEditor, ProductSearch, ActionFooter, ExternalLinkIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})